import {RouteInfo} from './vertical-menu.metadata';
import {Controles} from '../constants/controles';


// Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'ft-home',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: 0,
    submenu: [],
  },
  {
    path: 'rh/vacaciones',
    title: 'Vacaciones',
    icon: 'ft-box',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: 0,
    submenu: []
  },
  {
    path: 'rh/calendario',
    title: 'Calendario',
    icon: 'ft-calendar',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: 0,
    submenu: []
  },
  {
    path: 'rh/permisos',
    title: 'Permisos',
    icon: 'ft-archive',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: 0,
    submenu: []
  },
  {
    path: '/personas/clientes',
    title: 'Clientes',
    icon: 'ft-user',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.CLIENTES_MENU,
    submenu: []
  },
  {
    path: '/personas/propietarios',
    title: 'Propietarios',
    icon: 'ft-user-check',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.PROPIETARIOS_MENU,
    submenu: []
  },
  {
    path: '/cxc',
    title: 'CXC',
    icon: 'ft-dollar-sign',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.CXC_MENU,
    submenu: [
      {
        path: '/facturacion/facturas',
        title: 'Facturación',
        icon: 'ft-file-text',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.FACTURACION_MENU,
        submenu: []
      },
      {
        path: '/facturacion/form-facturas',
        title: 'Nueva Factura',
        icon: 'ft-plus',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.FACTURACION_AGREGAR_FACTURA,
        submenu: []
      },
      {
        path: '/cxc/pagos',
        title: 'Pagos',
        icon: 'ft-bar-chart-2',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.PAGOS_MENU,
        submenu: []
      },
      {
        path: '/cxc/estado-cuenta',
        title: 'Estado de Cuenta',
        icon: 'ft-clipboard',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.ESTADO_CUENTA_CXC_MENU,
        submenu: []
      },
      {
        path: '/cxc/antiguedad-saldos',
        title: 'Antigüedad de Saldos',
        icon: 'bi bi-clipboard2-pulse',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.ANTIGUEDAD_SALDOS_CXC_MENU,
        submenu: []
      },
      {
        path: '/cxc/reporte-timbrado',
        title: 'Reporte Timbrado',
        icon: 'ft-bell',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.REPORTE_TIMBRADO_CXC_MENU,
        submenu: []
      },
      {
        path: '/graficos/cxc',
        title: 'Gráficos',
        icon: 'ft-activity',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.GRAFICOS_CXC,
        submenu: []
      }
    ]
  },
  {
    path: '/cxp',
    title: 'CXP',
    icon: 'ft-briefcase',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.CXP_MENU,
    submenu: [
      {
        path: '/proveedores/proveedores',
        title: 'Proveedores',
        icon: 'ft-truck',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.PROVEEDORES_MENU,
        submenu: []
      },
      {
        path: '/requisiciones/requisiciones',
        title: 'Requisiciones',
        icon: 'ft-clipboard',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.REQUISICIONES_MENU,
        submenu: []
      },
      {
        path: '/facturacion-cxp/facturacion-cxp',
        title: 'Facturación',
        icon: 'ft-file-text',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.CXP_FACTURACION_MENU,
        submenu: []
      },
      {
        path: '/pagos-cxp/pagos-cxp',
        title: 'Pagos',
        icon: 'ft-bar-chart-2',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.CXP_PAGOS_MENU,
        submenu: []
      },
      {
        path: '/pagos-cxp/form-pagos',
        title: 'Nuevo Pago',
        icon: 'ft-plus',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.CXP_PAGOS_AGREGAR_PAGO,
        submenu: []
      },
      {
        path: '/graficos/cxp',
        title: 'Gráficos',
        icon: 'ft-activity',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.GRAFICOS_CXP,
        submenu: []
      }
    ]
  },
  {
    path: '/patrimonios',
    title: 'Arrendamiento',
    icon: 'ft-home',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.ARRENDAMIENTO_MENU,
    submenu: [
      {
        path: '/patrimonios/inventariopropiedades',
        title: 'Propiedades',
        icon: 'ft-map',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.PATRIMONIOS_MENU,
        submenu: []
      },
      {
        path: '/patrimonios/reporte-pld',
        title: 'Reporte PLD',
        icon: 'bi bi-file-earmark-excel',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.REPORTE_PLD_MENU,
        submenu: []
      },
      {
        path: '/patrimonios/acuses-pld',
        title: 'Acuses PLD',
        icon: 'bi bi-file-earmark-post',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.ACUSES_PLD_MENU,
        submenu: []
      }
    ]
  },
  {
    path: '/legal',
    title: 'Legal',
    icon: 'ft-book',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.LEGAL_MENU,
    submenu: [
      {
        path: '/prediales/pagos-prediales',
        title: 'Pagos Prediales',
        icon: 'ft-briefcase',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.PREDIALES_MENU,
        submenu: []
      },
      {
        path: '/seguros/seguros',
        title: 'Seguros',
        icon: 'ft-activity',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.SEGUROS_MENU,
        submenu: []
      },
      {
        path: '/licencias/licencias',
        title: 'Licencias',
        icon: 'ft-crop',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.LICENCIAS_MENU,
        submenu: []
      },
    ]
  },
  {
    path: '/contabilidad/interfaces-contpaqi',
    title: 'Interfaz ContPAQi',
    icon: 'ft-database',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.CONTABILIDAD_INTERFAZ_CONTPAQI,
    submenu: []
  },
  {
    path: '/comprobacion-gastos/comprobaciones',
    title: 'Gastos / Caja Chica',
    icon: 'bi bi-wallet',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.COMPROBACION_GASTOS,
    submenu: []
  },
  {
    path: '/utileria',
    title: 'Utileria',
    icon: 'ft-server',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.UTILERIA_MENU,
    submenu: [
      {
        path: '/utileria/administracion',
        title: 'Administración',
        icon: 'ft-settings',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.UTILERIA_ADMINISTRACION,
        submenu: []
      },
      {
        path: '/utileria/log-login',
        title: 'Log Login',
        icon: 'bi bi-person-check-fill',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.UTILERIA_LOG_LOGIN,
        submenu: []
      },
      {
        path: '/utileria/seguridad',
        title: 'Seguridad',
        icon: 'bi bi-shield-fill-check',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.UTILERIA_SEGURIDAD,
        submenu: []
      }
    ]
  }

];
